import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';

export const downloadCsvFile = (fileName, content) => {
  const contentType = 'data:text/csv;charset=utf-8;';
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  return link;
};

export const generateFileName = ({ type, to, businessHours = false }) => {
  let name = `${type}-report-${format(fromUnixTime(to), 'dd-MM-yyyy')}`;
  if (businessHours) {
    name = `${name}-business-hours`;
  }
  return `${name}.csv`;
};

/**
 * ActiveStorage redirect URLs 302 to Azure/S3. Proxy keeps bytes same-origin.
 * Also upgrades http→https / same-host relative paths to avoid mixed content
 * when FRONTEND_URL is configured with http://.
 */
export const toActiveStorageProxyUrl = url => {
  if (!url || typeof url !== 'string') return url;

  let next = url
    .replace(/^http:\/\//i, 'https://')
    .replace(
      '/rails/active_storage/blobs/redirect/',
      '/rails/active_storage/blobs/proxy/'
    )
    .replace(
      '/rails/active_storage/nxt/redirect/',
      '/rails/active_storage/nxt/proxy/'
    );

  try {
    const parsed = new URL(next, window.location.origin);
    if (parsed.host === window.location.host) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    // keep absolute URL
  }

  return next;
};

const fileNameFromUrl = url => {
  try {
    const path = new URL(url, window.location.origin).pathname;
    const segment = path.substring(path.lastIndexOf('/') + 1);
    return segment ? decodeURIComponent(segment) : '';
  } catch {
    return '';
  }
};

/**
 * Download via same-origin ActiveStorage proxy.
 * Uses an <a> navigation (not fetch) so http data_urls cannot trigger mixed-content blocks.
 */
export const downloadAttachmentFile = ({ url, fileName = null } = {}) => {
  if (!url) {
    throw new Error('Invalid download parameters');
  }

  const proxyUrl = toActiveStorageProxyUrl(url);
  const link = document.createElement('a');
  link.href = proxyUrl;
  link.rel = 'noopener';
  const resolvedName = fileName || fileNameFromUrl(proxyUrl);
  if (resolvedName) {
    link.setAttribute('download', resolvedName);
  }

  document.body.appendChild(link);
  link.click();
  link.remove();
};
